import { render, staticRenderFns } from "./ThemedSlide.vue?vue&type=template&id=ec942a1c&scoped=true&lang=pug"
import script from "./ThemedSlide.vue?vue&type=script&lang=ts"
export * from "./ThemedSlide.vue?vue&type=script&lang=ts"
import style0 from "./ThemedSlide.vue?vue&type=style&index=0&id=ec942a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec942a1c",
  null
  
)

export default component.exports